<template>
    <article
        :style="x && y ? { left: x + 'px', top: y + 'px' } : {}"
        class="c-drag"
        :class="className"
        @mousedown="refresh"
        data-transfer="true"
        style="will-change: top, left;"
    >
        <header
            @mousedown="drag_ev1"
            @mouseup="drag_ev3"
            class="c-drag-title"
            :class="`${className}-title`"
            v-if="$slots.default || $slots.title"
        >
            <slot name="title" v-if="$slots.title" />
            <slot v-else />
            <i-Icon
                v-if="closeable"
                type="ios-close"
                class="close"
                @click="$emit('on-close')"
            />
        </header>
        <i-Icon
            v-else-if="closeable"
            type="ios-close"
            class="no-title-close"
            @click="$emit('on-close')"
        />
        <main class="c-drag-content" :class="`${className}-content`">
            <slot name="content" />
        </main>
        <footer
            class="c-drag-footer"
            :class="`${className}-footer`"
            v-if="$slots.footer"
        >
            <slot name="footer" />
        </footer>
    </article>
</template>

<script>
let [x, y] = [0, 0]
let [offset_x, offset_y] = [0, 0]

export default {
    props: {
        className: { type: String, default: 'c-drag' },
        position: { type: Array, default: () => [] },
        closeable: { type: Boolean, default: true }
    },
    data() {
        return {
            drag: false,
            x: this.position[0],
            y: this.position[1]
        }
    },
    methods: {
        refresh() {
            document.querySelectorAll('article.c-drag').forEach(ele => {
                ele.style.zIndex = ele === this.$el ? 101 : 100
            })
        },
        drag_ev1(e) {
            if (e.button == 0) {
                this.x = this.$el.offsetLeft
                this.y = this.$el.offsetTop

                this.drag = !this.drag ? true : false
                ;[x, y] = [e.x, e.y]

                window.addEventListener('mousemove', this.drag_ev2)
                document.body.style.userSelect = 'none'
            }
        },
        drag_ev2(e) {
            if (this.drag) {
                if (e.which == 1) {
                    ;[offset_x, offset_y] = [e.x - x, e.y - y]
                    ;[x, y] = [e.x, e.y]
                    this.x += offset_x
                    this.y += offset_y
                } else {
                    this.drag_ev3()
                }
            }
        },
        drag_ev3(e) {
            this.drag = false
            window.removeEventListener('mousemove', this.drag_ev2)
            document.body.style.userSelect = 'text'
        }
    }
}
</script>
